import Follower from './Follower';
import { MODE_SEEK } from '../constants/AppConstants';

const MAX_SPEED = 300; // [px / s]

export default class Seeker extends Phaser.Group {
  constructor(game, seekerId, navPoints, startPosition, xMin, xMax) {
    super(game);
    this.seekerId = seekerId;
    this.navPoints = navPoints;
    this.xMin = xMin;
    this.xMax = xMax;
    this.allFound = false;
    // this.currentNavId = startNavPoint;

    this.onStartWalk = new Phaser.Signal();
    this.onPosition = new Phaser.Signal();
    this.onAnimEnd = new Phaser.Signal();

    //
    this.levelRef = this.game.state.getCurrentState();

    //
    this.skin = this.game.make.spine(0, 0, this.seekerId, true);
    this.skin.anchor.set(0.5, 1);
    this.addChild(this.skin);

    this.update();
    this.updateTransform();

    // animations
    this.mixAnimations();

    //
    this.currentAnim = '';
    this.playAnim('idle');

    //
    this.skin.setSkinByName('base');

    //
    this.x = this.destX = startPosition; // this.navPoints[this.currentNavId];

    //
    this.skin.skeleton.getRootBone().scaleX = 0.4;
    this.skin.skeleton.getRootBone().scaleY = 0.4;

    // add follower for Twins
    if (this.seekerId === 'twins') {
      this.follower = new Follower(this.game, 'mary', this);
    }

    //
    if (this.game.controller.gameMode === MODE_SEEK) {
      this.createButton();
    }
  }

  mixAnimations() {
    this.skin.setMixByName('walk', 'idle', 0.2);
    this.skin.setMixByName('idle', 'walk', 0.2);
    this.skin.setMixByName('idle', 'pointing', 0.2);
    this.skin.setMixByName('pointing', 'idle', 0.2);
    this.skin.setMixByName('idle', 'quizzical', 0.2);
    this.skin.setMixByName('quizzical', 'idle', 0.2);
    this.skin.setMixByName('idle', 'talking', 0.2);
    this.skin.setMixByName('talking', 'idle', 0.2);
    this.skin.setMixByName('idle', 'cheering', 0.2);
    this.skin.setMixByName('cheering', 'idle', 0.2);

    this.skin.setMixByName('pointing', 'talking', 0.2);
    this.skin.setMixByName('walk', 'pointing', 0.2);
    this.skin.setMixByName('cheering', 'walk', 0.2);
    this.skin.setMixByName('walk', 'quizzical', 0.2);
  }

  createButton() {
    this.button = this.game.make.button(0, 0, 'slot_marker');
    this.button.width = this.skin.width * 0.4;
    this.button.height = this.skin.height * 0.4;
    if (this.seekerId === 'elinor') {
      // exception for elinor
      this.button.height = this.skin.height * 0.5;
    }
    this.button.alpha = 0;
    this.button.anchor.set(0.5, 1);
    this.addChild(this.button);
    this.button.inputEnabled = true;
    this.button.events.onInputDown.add(this.handleInputDown, this);
    this.button.input.useHandCursor = false;
  }

  handleInputDown() {
    if (this.currentAnim === 'idle' && !this.allFound && !this.levelRef.hintPlaying) {
      if (this.sndTalking && this.sndTalking.isPlaying) {
        return;
      }

      const snd = 'vo_01_' + this.seekerId + '_';
      const ids = ['026', '030'];
      const ind = Phaser.Math.between(0, ids.length - 1);
      const textId = snd + ids[ind];
      this.game.springRollCaptionsPlugin.playCaption(textId);
      this.sndTalking = this.game.sounds
        .playVO(textId, {
          spriteID: this.seekerId + '_vo',
        })
        .get(textId);
      this.talk();
    }
  }

  stopTalking() {
    if (this.sndTalking && this.sndTalking.isPlaying) {
      this.sndTalking.stop();
      this.sndTalking = null;
      this.handleAnimTalkEnd();
    }
  }

  getDestX() {
    return this.x;
  }

  playAnim(anim, loop = true) {
    if (this.currentAnim !== anim) {
      this.currentAnim = anim;
      this.skin.setAnimationByName(0, anim, loop);
      // const track = this.skin.setAnimationByName(0, anim, loop);

      // walking sound
      if (anim === 'walk') {
        this.game.sounds.playSFX('walking', { loop: true, spriteID: 'sfx_location' });
      } else {
        this.game.sounds.stopAudioSprite('walking', { spriteID: 'sfx_location' });
      }
    }
  }

  startTalkForward(time = 500) {
    // const skin = this.skin.createCombinedSkin('mouth/talking', 'base');
    this.skin.setSkinByName('mouth/talking');
    this.refreshSkin();

    this.playAnim('idle_forward');

    this.game.time.events.add(time, this.stopTalkForward, this);
  }

  stopTalkForward() {
    this.skin.setSkinByName('base');
    this.refreshSkin();
    this.playAnim('idle');
  }

  refreshSkin() {
    const rb = this.skin.skeleton.getRootBone();
    const x0 = rb.scaleX;
    const y0 = rb.scaleY;
    this.skin.setToSetupPose();
    rb.scaleX = x0;
    rb.scaleY = y0;
  }

  idle() {
    this.playAnim('idle');
  }

  pointCharacter() {
    this.playAnim('pointing', false);
    //
    if (this.follower) {
      this.follower.playAnim('pointing', false);
    }
    //
    this.game.time.events.add(400, this.handleAnimEnd, this);
  }

  think() {
    this.playAnim('quizzical');
    //
    if (this.follower) {
      this.follower.playAnim('quizzical', false);
    }
    //
    this.game.time.events.add(1000, this.handleAnimEnd, this);
  }

  celebrate() {
    this.playAnim('cheering');
    //
    if (this.follower) {
      this.follower.playAnim('cheering', false);
    }
    //
    this.game.time.events.add(1100, this.handleAnimEnd, this);
  }

  talk(time = 1000, delay = 0) {
    if (delay > 0) {
      this.game.time.events.add(delay, this.talk, this, time);
    } else {
      this.playAnim('talking');
      //
      if (this.follower) {
        this.follower.playAnim('talking', false);
      }
      //
      this.game.time.events.add(time, this.handleAnimTalkEnd, this);
    }
  }

  handleAnimTalkEnd() {
    if (this.currentAnim === 'talking') {
      this.playAnim('idle');
    }
    this.handleAnimEnd();
  }

  handleAnimEnd() {
    this.onAnimEnd.dispatch();
  }

  gotoNextNavPoint() {
    if (this.currentNavId < this.navPoints.length - 1) {
      this.currentNavId++;
    }
    this.destX = this.navPoints[this.currentNavId];
    this.playAnim('walk');
  }

  gotoPrevNavPoint() {
    if (this.currentNavId > 0) {
      this.currentNavId--;
    }
    this.destX = this.navPoints[this.currentNavId];
    this.playAnim('walk');
  }

  setPosition(x) {
    this.x = this.destX = x;
    this.playAnim('idle');
  }

  gotoPosition(x) {
    this.destX = Phaser.Math.clamp(x, this.xMin, this.xMax);

    if (this.destX !== this.x) {
      const dir = this.destX > this.x ? 1 : -1;
      this.setDirection(-dir);

      this.playAnim('walk');

      this.onStartWalk.dispatch();
    } else if (this.destX !== x) {
      // if seek has to go to new position but it didnt changed - was out of the area - dispatch onPosition event
      this.onPosition.dispatch();
    }
  }

  atFirstNavPoint() {
    return this.x <= this.navPoints[0] + 1;
  }

  atLastNavPoint() {
    return this.x >= this.navPoints[this.navPoints.length - 1] - 1;
  }

  stop() {
    this.destX = this.x;
    this.playAnim('idle');

    this.onPosition.dispatch();
  }

  step(dt) {
    if (this.destX !== this.x) {
      const dir = this.destX > this.x ? 1 : -1;
      const dx = Math.min(Math.abs(this.destX - this.x), MAX_SPEED * dt);
      this.x += dir * dx;

      this.setDirection(-dir);

      if (Math.abs(this.x - this.destX) < 1) {
        this.x = this.destX;
        this.playAnim('idle');

        this.onPosition.dispatch();
      }
    }

    //
    if (this.follower) {
      this.follower.step(dt);
    }
  }

  setDirection(dir) {
    // this.skin.scale.x = dir;
    this.skin.skeleton.getRootBone().scaleX = 0.4 * dir;
    // this.update();
    // this.updateTransform();
  }

  destroy() {
    this.game.sounds.stopAudioSprite('walking', { spriteID: 'sfx_location' });
    super.destroy();
  }
}
